<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select
                v-model="form.detallePlanPagoConceptoUniversidadId"
                :items="detallesPlanesPagosConceptosUniversidades"
                item-value="id"
                item-text="nombre"
                label="Concepto"
                outlined
                dense
                hide-details
                :disabled="!!form.id"
                :item-disabled="(item) => !item.planPagoConceptoUniversidad.estaActivo"
                @change="() => (form.detallesSolicitudesPagos = [])">
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.nombre }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      {{ formatearValorAMoneda(item.monto) }}
                      {{ item.planPagoConceptoUniversidad.estaActivo ? '' : '(Inactivo)' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>

              <small
                v-for="error in errores.detallePlanPagoConceptoUniversidadId"
                :key="error"
                class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                :value="detallePlanPagoConceptoUniversidad?.numeroCuota"
                type="number"
                label="N° Cuota"
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                :value="detallePlanPagoConceptoUniversidad?.monto"
                type="number"
                label="Monto"
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                :value="numeroDetallesSolicitudesPagos"
                type="number"
                label="N° Estudiantes"
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                v-model="montoTotal"
                type="number"
                label="Monto Total"
                outlined
                dense
                hide-details
                readonly></v-text-field>

              <small v-for="error in errores.montoTotal" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="9" xl="10">
              <v-btn
                class="mx-1"
                color="primary"
                title="Agregar Estudiantes"
                small
                :disabled="!form.detallePlanPagoConceptoUniversidadId"
                @click="$refs.modalFormularioDetallesSolicitudesPagos.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Estudiantes
              </v-btn>

              <v-btn small class="mx-1" :disabled="item == null" title="Quitar" @click="() => quitarItem(item)">
                <v-icon>mdi-close</v-icon>

                Quitar
              </v-btn>
            </v-col>

            <v-col cols="12">
              <ListadoDetallesSolicitudesPagos
                ref="listadoRef"
                :items="form.detallesSolicitudesPagos"
                :cargando="cargando"
                @selectItem="selectItem" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :loading="enviando"
          :disabled="enviando"
          @click.prevent="$refs.confirmacionRef1.abrir">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef1"
      :titulo="confirmacion1.titulo"
      :mensaje="confirmacion1.mensaje"
      :realizandoAccion="confirmacion1.realizandoAccion"
      @aceptar="confirmacion1.fnAceptar" />

    <ModalFormularioDetallesSolicitudesPagos
      ref="modalFormularioDetallesSolicitudesPagos"
      :nombreRecurso="nombreItem"
      :programaUniversidadId="form.programaUniversidadId"
      :detallePlanPagoConceptoUniversidadId="form.detallePlanPagoConceptoUniversidadId"
      :planPagoUniversidadId="programaUniversidad?.planPagoUniversidadId"
      :detallesSolicitudesPagos="form.detallesSolicitudesPagos"
      @agregarDetallesSolicitudesPagos="agregarDetallesSolicitudesPagos" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import SolicitudPagoService from '../services/solicitud-pago.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import InscripcionProgramaUniversidadService from '../services/inscripcion-programa-universidad.service';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';
import ListadoDetallesSolicitudesPagos from './ListadoDetallesSolicitudesPagos.vue';
import layoutMixin from '../mixins/layout.mixin';
import ModalFormularioDetallesSolicitudesPagos from './ModalFormularioDetallesSolicitudesPagos.vue';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import { concatenar, formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'ModalFormularioSolicitudPago',
  mixins: [modalFormMixin, apiConsumerMixin, layoutMixin],
  components: {
    ConfirmacionAccion,
    ListadoDetallesSolicitudesPagos,
    ModalFormularioDetallesSolicitudesPagos,
  },
  props: {
    programaUniversidadId: {
      type: [Number],
      required: true,
    },
  },
  data() {
    return {
      nombreItem: 'Detalle Solicitud Pago',
      inscritosProgramaUniversidad: [],
      programaUniversidad: null,
      confirmacion1: {
        titulo: 'Guardar Solicitud de Pago',
        mensaje: '¿Está seguro que desea realizar la solicitud de pago?',
        realizandoAccion: false,
        fnAceptar: () => this.validar(this.registrar, this.editar),
      },
    };
  },
  computed: {
    detallesPlanesPagosConceptosUniversidades() {
      const detallesPlanesPagosConceptosUniversidades = [];

      this.programaUniversidad?.planPagoUniversidad?.planesPagosConceptosUniversidades.forEach(
        (planPagoConceptoUniversidad) => {
          planPagoConceptoUniversidad.detallesPlanesPagosConceptosUniversidades.forEach(
            (detallePlanPagoConceptoUniversidad) => {
              detallesPlanesPagosConceptosUniversidades.push({
                id: detallePlanPagoConceptoUniversidad.id,
                planPagoUniversidadId: this.programaUniversidad?.planPagoUniversidadId,
                planPagoUniversidad: {
                  id: this.programaUniversidad?.planPagoUniversidad.id,
                  nombre: this.programaUniversidad?.planPagoUniversidad.nombre,
                },
                planPagoConceptoUniversidadId: planPagoConceptoUniversidad.id,
                planPagoConceptoUniversidad: {
                  id: planPagoConceptoUniversidad.id,
                  montoTotal: planPagoConceptoUniversidad.montoTotal,
                  porcentaje: planPagoConceptoUniversidad.porcentaje,
                  monto: planPagoConceptoUniversidad.monto,
                  numeroCuotas: planPagoConceptoUniversidad.numeroCuotas,
                  orden: planPagoConceptoUniversidad.orden,
                  estaActivo: planPagoConceptoUniversidad.estaActivo,
                  conceptoUniversidad: {
                    concepto: {
                      nombre: planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre,
                    },
                  },
                },
                nombre:
                  planPagoConceptoUniversidad.numeroCuotas > 1
                    ? `${detallePlanPagoConceptoUniversidad.numeroCuota}° Cuota - ${planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre}`
                    : planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre,
                numeroCuota: detallePlanPagoConceptoUniversidad.numeroCuota,
                monto: detallePlanPagoConceptoUniversidad.monto,
              });
            },
          );
        },
      );

      return detallesPlanesPagosConceptosUniversidades;
    },
    detallePlanPagoConceptoUniversidad() {
      return this.detallesPlanesPagosConceptosUniversidades.find(
        (detallePlanPagoConceptoUniversidad) =>
          detallePlanPagoConceptoUniversidad.id === this.form.detallePlanPagoConceptoUniversidadId,
      );
    },
    numeroInscritosProgramaUniversidad() {
      return this.inscritosProgramaUniversidad.length;
    },
    numeroDetallesSolicitudesPagos() {
      return this.form?.detallesSolicitudesPagos?.length;
    },
    montoTotal() {
      const monto = this.detallePlanPagoConceptoUniversidad?.monto || 0;

      return (this.numeroDetallesSolicitudesPagos * monto).toFixed(2);
    },
  },
  watch: {
    'form.conceptoUniversidadId': function () {
      this.errores.conceptoUniversidadId = [];
    },
    numeroInscritosProgramaUniversidad: function () {
      this.errores.numeroInscritosProgramaUniversidad = [];
    },
    detallePlanPagoConceptoUniversidad: function (val) {
      this.form.numeroCuota = val?.numeroCuota;
      this.form.monto = val?.monto;
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaUniversidadId: this.programaUniversidadId,
        detallePlanPagoConceptoUniversidadId: null,
        numeroCuota: null,
        monto: null,
        nombreSolicitante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        solicitanteId: this.$store.state.DATA_USER.id,
        sedeId: this.$store.state.cargo_sede.sede.id,
        detallesSolicitudesPagos: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaUniversidadId: data.programaUniversidadId,
        detallePlanPagoConceptoUniversidadId: data.detallePlanPagoConceptoUniversidadId,
        numeroCuota: data.numeroCuota,
        monto: data.monto,
        nombreSolicitante: data.nombreSolicitante,
        solicitanteId: data.solicitanteId,
        sedeId: data.sedeId,
        detallesSolicitudesPagos: data.detallesSolicitudesPagos,
      };
    },
    async obtenerProgramaUniversidad() {
      await this.obtenerDatosV2Mixin(
        ProgramaUniversidadService.findOne,
        'programaUniversidad',
        this.programaUniversidadId,
      );
    },
    async obtenerInscritosProgramaUniverdidad() {
      this.inscritosProgramaUniversidad = [];

      await this.obtenerDatosMixin(InscripcionProgramaUniversidadService.findAll, 'inscritosProgramaUniversidad', {
        programaUniversidadId: this.programaUniversidadId,
      });
    },
    abrir(accion, data = []) {
      Promise.all([this.obtenerProgramaUniversidad(), this.obtenerInscritosProgramaUniverdidad()]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    guardar(accion) {
      this.guardarDatosMixin(
        SolicitudPagoService.create,
        SolicitudPagoService.update,
        accion,
        {
          ...this.form,
          detallesSolicitudesPagos: this.form.detallesSolicitudesPagos.map((detalle) => {
            return {
              id: detalle.id,
              inscripcionProgramaUniversidadId: detalle.inscripcionProgramaUniversidadId,
            };
          }),
        },
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    agregarDetallesSolicitudesPagos(detallesSolicitudesPagos) {
      detallesSolicitudesPagos.forEach((detalleSolicitudPago) => {
        const inscripcion = detalleSolicitudPago.inscripcion;
        const { estudiante, programa } = inscripcion;

        this.form.detallesSolicitudesPagos.push({
          id: null,
          inscripcionProgramaUniversidadId: detalleSolicitudPago.id,
          inscripcionProgramaUniversidad: {
            inscripcion: {
              id: inscripcion.id,
              estudiante: {
                id: estudiante.id,
                numeroDocumento: estudiante.numeroDocumento,
                nombres: estudiante.nombres,
                primerApellido: estudiante.primerApellido,
                segundoApellido: estudiante.segundoApellido,
                sexo: estudiante.sexo,
                telefono1: estudiante.telefono1,
                telefono2: estudiante.telefono2,
                email: estudiante.email,
                profesiones: estudiante.profesiones,
                institucion: estudiante.institucion,
              },
              programaId: inscripcion.programaId,
              programa: {
                id: programa.id,
                nombreCompuesto: programa.nombreCompuesto,
                sedeId: programa.sedeId,
                sede: {
                  id: programa.sede.id,
                  nombre: programa.sede.nombre,
                },
              },
              estadoAcademicoId: inscripcion.estadoAcademicoId,
              estadoAcademico: inscripcion.estadoAcademico,
            },
          },
          creadoEn: null,
        });
      });
    },
    quitarItem(item) {
      this.form.detallesSolicitudesPagos.splice(
        this.form.detallesSolicitudesPagos.findIndex(
          (detalleSolicitudPago) =>
            detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion.id ===
            item.inscripcionProgramaUniversidad.inscripcion.id,
        ),
        1,
      );
      this.item = null;
    },
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>